import { Client } from 'api/getClient';
import { areEmployerStepsRequired } from 'utils/employerClient';

export const shouldNavigateToFinance = (client: Client | null | undefined) => {
  const phoneVerificationDone = Boolean(client?.mobilePhoneVerified);
  const employmentUndefined = !client?.employer.employmentStatus;
  const employmentDetailsRequired =
    areEmployerStepsRequired(client?.employer.employmentStatus) &&
    !client?.employer.employmentDetail;

  return (
    phoneVerificationDone && (employmentUndefined || employmentDetailsRequired)
  );
};
